module.exports = __webpack_public_path__ + "static/appstore-mobile-0b9d60c4a07a3ffafe77070fa9e661de.png";